/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
import { ref } from "vue";
import { SnapshotEventType } from "../firebase";
export function vueFirestoreDocRef(snap) {
    // Create the ref and set its initial data
    var data = snap.data({ clone: true });
    var _ref = ref(data);
    // Whenever the snapshot updates write the latest data out
    snap.onUpdate((event) => {
        switch (event.type) {
            case SnapshotEventType.Created:
            case SnapshotEventType.Updated:
            case SnapshotEventType.Fetched:
                _ref.value = snap.data({ clone: true });
                break;
            case SnapshotEventType.Deleted:
                _ref.value = null;
                break;
        }
    });
    return _ref;
}
export function vueFirestoreSubsetRef(subset) {
    var _ref = ref([]);
    subset.onUpdate((event) => {
        switch (event.type) {
            case SnapshotEventType.Created:
            case SnapshotEventType.Updated:
            case SnapshotEventType.Fetched:
                _ref.value = subset.dataItems({ clone: true });
                break;
            case SnapshotEventType.Deleted:
                _ref.value = null;
                break;
        }
    });
    return _ref;
}
//# sourceMappingURL=vue-firestore-refs.js.map